import { initState } from './AuthReducer'

// A session that lost its access token used to be written to localStorage, where it
// survived closing the tab and kept the visitor stuck: the app looked logged in, yet
// every protected page pushed them away. Broken sessions are dropped while the stored
// state is read, so an existing one heals on the next page load instead of needing a
// manual logout.
//
// Written without optional chaining on purpose, see the note in selectors/authSelector.
const sanitizeAuthState = authState => {
  const user = authState && authState.user
  if (!user) {
    return authState
  }

  if (user.accessToken) {
    return authState
  }

  // Nothing claims a session here, so there is nothing to clean up.
  if (!user.isAuthenticated && !user.refreshToken) {
    return authState
  }

  return { ...authState, user: { ...initState.user } }
}

export default sanitizeAuthState



// WEBPACK FOOTER //
// ./src/reducers/sanitizeAuthState.js